import { render } from "./AppleInstallPwa.vue?vue&type=template&id=9b5ea2da&scoped=true"
import script from "./AppleInstallPwa.vue?vue&type=script&lang=js"
export * from "./AppleInstallPwa.vue?vue&type=script&lang=js"

import "./AppleInstallPwa.vue?vue&type=style&index=0&id=9b5ea2da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b5ea2da"

export default script